import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { ICancelPosRequest } from '../models/models'

export class CancelPosApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/payment/CancelPos',
      requesterInfo,
    })
  }

  public async cancelPos(req: ICancelPosRequest): Promise<any> {
    return await this.postAsync<any>(req)
  }
}
